export default __webpack_public_path__ + "static/media/48-icon-menu.74c434ff.svg";